module.exports = [
    "yyyy-mm-dd",
    "dd.mm.yyyy",
    "dd.mm.yy",
    "dd/mm/yy",
    "mm-dd-yy"
];